import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Article from './components/sections/Article';
import SideMenu from './components/sections/SideMenu';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import articlesData from './data/article.json'; // Import the articles JSON data

function App() {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    // Load the sections from the JSON file
    setSections(articlesData.sections);
  }, []);

  return (
    <Router>
      <div className="flex flex-col h-screen">
        {/* Header */}
        <Header />

        {/* Content Area (Main Area with side menu and article content) */}
        <div className="flex flex-1 overflow-hidden">
          <Routes>
            {/* Home Page */}
            <Route path="/" element={
               <div className="flex w-full h-full">
               <HomePage />
               </div>
            } />

            {/* Articles Section (with side menu) */}
            <Route
              path="/articles"
              element={
                <div className="flex w-full h-full">
                  <SideMenu sections={sections} />
                  <div className="flex-1 p-6 overflow-auto">
                    <p>Select an article from the menu.</p>
                  </div>
                </div>
              }
            />

            {/* Individual Article Page */}
            <Route
              path="/article/:articleId"
              element={
                <div className="flex w-full h-full">
                  <SideMenu sections={sections} />
                  <div className="flex-1 p-6 overflow-auto">
                    <Article sections={sections} />
                  </div>
                </div>
              }
            />
          </Routes>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
